module.exports = __webpack_public_path__ + "static/media/eq_lcgh_icon.044ae781.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/eq_lcgh_icon.png
// module id = 697
// module chunks = 0 1